module.exports = __webpack_public_path__ + "static/media/22712645_2403125593244918_1428490761_o.04eb178f.jpg";